import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import "../footer.scss";

const Footer = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            IT_joripara,
            IT_total,
            IT_paied,
            IT_discount,
            IT_Note
          } = value;
          return (
            <>
              <html dir="rtl">
                <div className="row fk">
                  <div className="col-2"></div>
                  <div className="col-6">
                    {!IT_Note ? "ملاحظة : لا یمکن ارجاع او یبدل المادة" : `${IT_Note}:ملاحظة`}
                  </div>
                  <div className="col-4">
                    <table className="responstable">
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          مجموع
                        </th>
                        <td
                          className="text-danger1"
                          style={{
                            fontSize: "25px",
                            backgroundColor: "#80bfea"
                          }}
                        >
                          <NumberFormat
                            value={IT_total}
                            thousandSeparator={true}
                            displayType="text"
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          خصم
                        </th>
                        <td style={{ fontSize: "25px" }}>
                          <NumberFormat
                            value={
                              IT_discount
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          دفع
                        </th>
                        <td style={{ fontSize: "25px" }}>
                          <NumberFormat
                            value={
                              IT_paied
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </html>

            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default Footer;
